import { TASK_PAGE, ATTENDANCE, ATTENDANCE_ACTION, BACKDATED_APPROVAL, BASE, PROFILE, SITE, DRIVE, LIST_BILLS, USER_PAGE, LEAVE_CALENDAR, LEAVE_REQUEST_LIST, LEAVE_APPROVALS, ESS, LEAVE_SUMMARY_LIST, SALARY_MASTER, SALARY_SLIP, LEAVE_CREDIT_DEBIT_LIST, EMP_REFERRAL_LIST, TRAINING } from "../routes";
import { USER_ROLES } from "./Strings";
//Note: In order to allow submenu to particular role then that role should be present in the parent route's role array.

export const MENU_ITEMS = [
  {
    name: "Dashboard",
    route: BASE,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
  },
  {
    name: "Drive",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
    SUB_MENU: [
      {
        name: "My Drive",
        route: DRIVE.replace(":type", "my"),
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Shared Drive",
        route: DRIVE.replace(":type", "shared"),
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
    ],
  },
  {
    name: "Profile",
    route: PROFILE,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
  },
  {
    name: "Training",
    route: TRAINING,
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
  },
  {
    name: "ESS",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
    SUB_MENU: [
      {
        name: "Employee Documents",
        route: ESS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Employee Referrals",
        route: EMP_REFERRAL_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
    ],
  },
  {
    name: "Manage",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
    SUB_MENU: [
      {
        name: "Attendance View",
        route: ATTENDANCE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Attendance Action",
        route: ATTENDANCE_ACTION,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Backdated Approvals",
        route: BACKDATED_APPROVAL,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Bills",
        route: LIST_BILLS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Task",
        route: TASK_PAGE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Site",
        route: SITE,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      { name: "Users", route: USER_PAGE, roles: [USER_ROLES.ADMIN, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT] },
    ],
  },
  {
    name: "Leave Management",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
    SUB_MENU: [
      {
        name: "Yearly Calendar",
        route: LEAVE_CALENDAR,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Leave Requests",
        route: LEAVE_REQUEST_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Leave Actions",
        route: LEAVE_APPROVALS,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Leave Summary",
        route: LEAVE_SUMMARY_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT]
      },
      {
        name: "Leave Credit/Debit",
        route: LEAVE_CREDIT_DEBIT_LIST,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT]
      }
    ],
  },
  {
    name: "Payroll",
    roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
    SUB_MENU: [
      {
        name: "Salary Master",
        route: SALARY_MASTER,
        roles: [USER_ROLES.ADMIN, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
      {
        name: "Salary Slip",
        route: SALARY_SLIP,
        roles: [USER_ROLES.ADMIN, USER_ROLES.PROJECT_INCHARGE, USER_ROLES.INCHARGE, USER_ROLES.SITE_STAFF, USER_ROLES.HR, USER_ROLES.DIRECTOR_MANAGEMENT],
      },
    ],
  },
];
